import { createRef, useMemo } from 'react';

const useCustomOtpInput = ({
  length,
  value,
  onChange,
  setErrors,
  handleLoginOtp,
}) => {
  const inputRefs = useMemo(
    () => Array.from({ length }, () => createRef()),
    [length]
  );

  const handleInputChange = (index, inputValue) => {
    setErrors({});
    const numericValue = inputValue.replace(/\D/g, '');
    const newValue = value.split('');
    newValue[index] = numericValue;
    const finalValue = newValue.join('').slice(0, length);
    onChange(finalValue);

    if (numericValue && index < length - 1) {
      inputRefs[index + 1].current?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !value[index] && index > 0) {
      inputRefs[index - 1].current?.focus();
    }
    if (e.key === 'Enter') {
      e.preventDefault();
      handleLoginOtp();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').replace(/\D/g, '');
    if (!pasteData) return;

    const newValue = pasteData.slice(0, length);
    onChange(newValue);

    const nextIndex = Math.min(newValue.length, length - 1);
    inputRefs[nextIndex]?.current?.focus();
  };

  return {
    inputRefs,
    handleInputChange,
    handleKeyDown,
    handlePaste,
  };
};

export default useCustomOtpInput;
